var page_n = 1 

var order = 1

prod_type = []

var done = false

reloaded = false

var count = ''

function sort(){
	selected_option = $( "#select_sort option:selected" ).text();
  if (selected_option == "Price: High to Low"){
    high_to_low()
      }
  else if(selected_option == "Price: Low to High"){
    low_to_high()
  }
  reload()
}


function add_to_cart(id, inventory_quantity = 999) {
  alert("custom_collection.js: ");
  
jQuery.getJSON('/cart.js', function(cart) {
  cart_count= cart.item_count 
  
  qt = 1
  
  
  total_cart =  parseInt(qt) + cart_count;
  
  $('#desk_icon span').text(total_cart);
  
  prod_name = $(".product-single__title").text();
  
  
  
  swal("The product was added to your cart",{
  buttons: {
    cancel: "Continue Shopping",
    catch: {
      text: "Go to Cart",
      value: "Cart",
    },
  },
})
.then((value) => {
  switch (value) {
 
    case "Cart":
     window.location.href = '/cart';
      break;

  }
});
  
  
  
    var jqXHR = $.ajax({
        type: "POST",
        async: false,
        url: '/cart/add.js',
        data: jQuery.param({
            id: id,
            quantity: qt
            
        }),
        success: function(data) {
      
        },
        error: function(data) {

        }
    });

    return (jQuery.parseJSON(jqXHR.responseText));
  
} );
  
  
}



function removeDuplicates(arr){
    let unique_array = []
    for(let i = 0;i < arr.length; i++){
        if(unique_array.indexOf(arr[i]) == -1){
            unique_array.push(arr[i])
        }
    }
    return unique_array
}

function high_to_low(){

   order = 0
}
function  low_to_high(){

   order = 1
}

function move_to(handle){
	window.location.href = "/products/"+handle;
}

function reset_page() {
  $('html, body').animate({
    scrollTop: ($('#header').first().offset().top)
},500);
	page_n = 1
}

function next_page() {
  $('html, body').animate({
    scrollTop: ($('#header').first().offset().top)
},500);
  page_n = parseInt(page_n) +1 


}

function previous_page(){
  $('html, body').animate({
    scrollTop: ($('#header').first().offset().top)
},500);
  page_n =parseInt(page_n)-1 
}


function change_page(clicked_id)
{
  $('html, body').animate({
    scrollTop: ($('#header').first().offset().top)
},500);
  page_n = clicked_id;
  reload()

}


function filter(final_list,header_title){
  
  cat_filters_ok = []
  
  return_val = []
  
  checked_val = []
  
  checked_class = []
  
   header_title = header_title.split('(')[0].trim().replace(/ /g,'').toLowerCase()

  
  if(header_title.includes("configuretoorder")){
    
    $('input.hard-drive:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal)
      checked_class.push(sThisClass)
    });
    
  }
  
    else if(header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9"){
    
    $('input.clock-speed:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal)
      checked_class.push(sThisClass)
    });
      
      $('input.cpu-cores:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal)
      checked_class.push(sThisClass)
    });
      
      $('input.hard-drive:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal)
      checked_class.push(sThisClass)
     });
      
      $('input.hdd-capacity:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal)
      checked_class.push(sThisClass)
    });
      
      $('input.server-model:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
    
    
  }
  
  else if (header_title == 'servers') {
    
  
     $('input.clock-speed:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
     $('input.cpu-cores:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
     $('input.hdd-capacity:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
    


    
    $('input.hard-drive:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
    

 
    
  	
  }
  
    else if(header_title == "parts" ){
    
    $('input.parts-type:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
  }
  
  else if(header_title == "harddrives" ){
    
    $('input.form-factor:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
        $('input.rpm:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
       $('input.interface:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
  }
  
    else if(header_title == "ram" ){
    
    $('input.capacity:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
        $('input.type:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
  }
  
  
      else if(header_title == "processor" ){
    
    $('input.cpu_cores:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
        $('input.cpu_threads:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
        
         $('input.clock-speed:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
        
            $('input.vitualization:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisClass = $(this).attr("class");
      checked_val.push(sThisVal);
      checked_class.push(sThisClass);
    });
    
  }
  
  if (checked_class.length == 0 ){
  	cat_filters_ok = final_list
  }
  

  for ( i=0;i < checked_class.length;i++){
    if (checked_class[i] == "hard-drive" && header_title.includes("configuretoorder")){
    	for ( z=0;z < final_list.length; z++ ){
          ch = checked_val[i].trim().replace(/ /g,'').toLowerCase().replace('sff','2.5"').replace('LFF','3.5"') + 'hot-swapbays';
          v = final_list[z].tags[0].trim().replace(/ /g,'').toLowerCase();
          
          if (v == ch){
          	cat_filters_ok.push(final_list[z])
          }
    }
  	
  } 
  }
  
  /*SERVER FILTER START*/
  
 
    server3 = []
  server_model = false
  for (i=0 ; i < checked_class.length ;i++){
    console.log(checked_val[i])
    if ( checked_class[i].includes("server-model") && (header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
     server_model = true
      for (z=0; z < final_list.length;z++){
    	v = final_list[z].title.toUpperCase().replace(/\s/g, '')
        ch = checked_val[i]
        if (v.includes(ch)){
        	server3.push(final_list[z])
        }
      	
      }
    	
    }
  }
  
  if(server_model == true ){final_list=server3}

  
  
  server1 = [] 
	
  clock_speed = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("clock-speed") && (header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
      clock_speed = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
          if (final_list[z].tags[m].includes("GHz Clock Speed")){
          	v = parseFloat(final_list[z].tags[m].replace("GHz Clock Speed",''))
            ch = parseFloat(checked_val[i].replace("<",'').replace("GHz",'').replace(">",""))
            if ( checked_val[i].includes('<') ){
            
                if( (v == ch) || (v < ch) ){
              
                  server1.push(final_list[z])
                }
            }
            else if ( checked_val[i].includes('>') ){
            
                if( (v > ch) ){
              
                  server1.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  }
  
  if ( clock_speed == true ){ final_list = server1 } 
  
 
  server2 = []
  cpu_cores = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("cpu-cores") && (header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
     cpu_cores = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
          if (final_list[z].tags[m].includes("Cores")){
          	v = parseFloat(final_list[z].tags[m].replace("Cores",''))
            ch = parseFloat(checked_val[i].replace("<",'').replace("Cores",'').replace(">",""))
            if ( checked_val[i].includes('<') ){
            
                if( (v == ch) || (v < ch) ){
              
                  server2.push(final_list[z])
                }
            }
            else if ( checked_val[i].includes('>') ){
             
            
                if( (v > ch) ){
              
                  server2.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  }
  
  if(cpu_cores == true){final_list=server2}
  
  raw_storage = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("hdd-capacity") && (header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
      raw_storage = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){

          if (final_list[z].tags[m].includes("Raw Storage")){
          	v = final_list[z].tags[m].replace("Raw Storage",'')
            ch = checked_val[i].replace("<",'').replace("Cores",'').replace(">","")
            if ( checked_val[i] == 'No Storage'){
  
                if( v.replace(/\s/g, '') == "0GB"  || v.replace(/\s/g, '') == "0TB"  ){
         
                  cat_filters_ok.push(final_list[z])
                }
            }
            
            else{
            if(checked_val[i].includes("TB")){
            	ch = checked_val[i].replace("TB","000")
            }
            
            else{
            	ch = checked_val[i].replace("GB","")
            }
            
            if(v.includes("TB")){
            	v = v.replace("TB","000")
            }
            
            else{
            	v = v.replace("GB","")
            }
            
           if ( ch.includes('<') ){
             	v=parseInt(v)
                ch=parseInt(ch.replace("<",""))
            
                if( (v == ch) || (v < ch) ){
              
                  cat_filters_ok.push(final_list[z])
                }
            }
            else if (ch.includes('>') ){
              	v=parseInt(v)
                ch=parseInt(ch.replace(">",""))
            
                if( (v > ch) ){
              
                  cat_filters_ok.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  }
  }
  
  
   if ((header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
  
  if (raw_storage == false && (header_title == "dellservers" || header_title == "dellpoweredge" || header_title == "servers" 
            || header_title == "dellpoweredger620"  || header_title == "dellpoweredger420"  || header_title == "hpservers"
            || header_title == "hpproLiant" || header_title == "hpproliantdl380g7" || header_title == "hpproLiantdel380g9" 
            || header_title == "hproLiantdl360g7" || header_title == "dellpoweredger710" || header_title == "dellpoweredger610"
            || header_title == "dellpoweredger720" || header_title == "hpproliantdl360pg8" || header_title == "hpproliantdl380pg8"
            || header_title == "dellpoweredger820" || header_title == "hpproliantdl360g9")){
    	cat_filters_ok = final_list
  }
   }
  /*SERVER FILTER END*/
  
  /*RAM FILTER START*/
  
   ram1 = [] 
	
  ram_capacity = false
  for (i=0 ; i < checked_class.length ;i++){
    
    if ( checked_class[i].includes("capacity") && header_title == "ram" ){
      ram_capacity = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
          if (final_list[z].tags[m].includes("Module")){
          	v = parseFloat(final_list[z].tags[m].replace("Module",'').replace("GB",''))
            ch = parseFloat(checked_val[i].replace("GB",''))
            if ( v == ch ){
                  ram1.push(final_list[z])
                  console.log("RAM:"+final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  
  if(ram_capacity == true){final_list=ram1}
  console.log(ram1)
  
  
  ram2 = [] 
	
  ram_speed = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("type") && header_title == "ram" ){
      ram_speed = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
          if (final_list[z].tags[m].includes("PC") && final_list[z].tags[m].length == 3){
          	v = final_list[z].tags[m].replace(/\s/g, '')
            ch =checked_val[i].replace(/\s/g, '')
            console.log(v)
            console.log(ch)
            if ( v == ch ){
          
                  cat_filters_ok.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  
    if (ram_speed == false && header_title == "ram" ){
    	cat_filters_ok = final_list
  }
  
  /*RAM FILTER END*/
  
  
  
  /*HDD FILTER START*/
  
   hdd1 = [] 
  hdd_form_factor = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("form-factor") && header_title == "harddrives" ){
      console.log("OK")
      hdd_form_factor = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
          if (final_list[z].tags[m].includes("Form Factor")){
          	v = final_list[z].tags[m].replace("Form Factor", '').replace(/\s/g, '').replace("3.5",'LFF').replace("2.5","SFF")
            ch = checked_val[i]
            console.log(v)
            console.log(ch)
            if ( v == ch ){
          
                  hdd1.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  
  if( hdd_form_factor == true){final_list=hdd1}

  
  hdd2 = [] 
  hdd_speed = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("rpm") && header_title == "harddrives" ){
    hdd_speed = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
           if (final_list[z].tags[m].includes("RPM")){
          	v = final_list[z].tags[m].replace(/\s/g, '').replace("RPM",'')
            ch =checked_val[i].replace(/\s/g, '')
            console.log(v)
            console.log(ch)
            if ( v == ch ){
          
                  hdd2.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  
 if( hdd_speed == true){final_list=hdd2}
  
  hdd3 = [] 
  hdd_interface = false
  for (i=0 ; i < checked_class.length ;i++){
    if ( checked_class[i].includes("interface") && header_title == "harddrives" ){
    hdd_interface = true
      for (z=0; z < final_list.length;z++){
        for (m=0;m < final_list[z].tags.length ; m++ ){
           if (final_list[z].tags[m].includes("SAS") || final_list[z].tags[m].includes("SATA") ){
          	v = final_list[z].tags[m].replace(/\s/g, '')
            ch =checked_val[i].replace(/\s/g, '')
            console.log(v)
            console.log(ch)
            if ( v == ch ){
          
                  cat_filters_ok.push(final_list[z])
                }
            }
            
          }
        	
        }
      	
      }
    	
    }
  
    if (hdd_interface == false && header_title == "harddrives"){
    	cat_filters_ok = final_list
  }
  

  
  /*HDD FILTER END*/
  
  
  
  
  
  cat_filters_ok =  [...new Set(cat_filters_ok)];
  
    collection_title = $( "#header" ).text()
  collection_name = collection_title.split("(")[0]
  collection_new = collection_name +" (" + String(cat_filters_ok.length) +")"
  $( "#header" ).empty();
  $( "#header" ).append(collection_new);
  
  
  return cat_filters_ok
}


$( document ).ready(function() {
  

  count_received = 0
  prod = []
  prod_final = []
  var url_handl = document.URL.split('/').pop();
  url_handl = url_handl.split('?')[0]
  var url_count ='/collections/'+url_handl+'/count'+'.json';

  $.getJSON(url_count, function(collection_count) {
  	count =  collection_count.collection.products_count

    max_page = Math.ceil(count / 250) + 1
    
    page = 1

    while (page < max_page ) {
      get_prod_url = '/collections/'+url_handl+'/products.json?limit=250&page=' + page;
      page++
        $.ajax({
        type: "GET",
        async: true,
        url: get_prod_url,
        success: function(data) {
            append_prod(data)
            count_received = count_received + data.products.length 
        },
        error: function(data) {
          console.log("ERROR")
        }
    });
      
      
    }

   
  });

           

function append_prod(info){
  for (i=0;i < info.products.length;i++){
  	prod_type.push(info.products[i].product_type)
  }
prod.push(info)
reload()
}
  
 
  
  });


function reload(){


  
  done = true
   
   
  var final_list = []
  var vendor_check = []
  var condition_check = []
  var checkbox_values = []
  var l_elements = []

    var price_max = $('#price-max').val();
    var price_min = $('#price-min').val();
  
    l_elements = []
    checkbox_values = []
    condition_check = []
    vendor_check = []
    

    $('input.checkb:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      var sThisVal2 = $(this).attr('id');
      checkbox_values.push(sThisVal2+":"+sThisVal)
    });
    
    $('input.check_vendor:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      vendor_check.push(sThisVal)
    });
    
     $('input.check_condition:checkbox:checked').each(function () {
      var sThisVal = $(this).val();
      condition_check.push(sThisVal)
    });
  
    for (i = 0;i < prod.length; i++){
      for (z = 0;z < prod[i].products.length; z++){
    		l_elements.push(prod[i].products[z])
      }
    }
  	
  var vendor_ok = []
  var condition_ok = []
  var price_min_ok = []
  var price_max_ok = []
  
    for (i = 0;i < l_elements.length;i++){
      if (vendor_check.length == 0){
        vendor_ok.push(l_elements[i])
      }
      else{
        for (x = 0; x < vendor_check.length;x++){
          if (vendor_check[x] == l_elements[i].vendor){
            vendor_ok.push(l_elements[i])
          }
        }
          }
        }

      
	for (i = 0;i < vendor_ok.length;i++){
      if (condition_check.length == 0){
      	condition_ok.push(vendor_ok[i])
      }
      else{
        for (x = 0; x < condition_check.length;x++){
          for (z = 0; z < vendor_ok[i].tags.length;z++){
            if (condition_check[x] == vendor_ok[i].tags[z]){
            	condition_ok.push(vendor_ok[i])
            }
          }
        
      }

      }
    }
  

  
  for (i = 0;i < condition_ok.length;i++){
    if (parseFloat(condition_ok[i].variants[0].price) >= parseFloat(price_min) ){
    	price_min_ok.push(condition_ok[i])
    }
  	
  }
  
  for (i = 0;i < price_min_ok.length;i++){
    if (parseFloat(price_min_ok[i].variants[0].price) <= parseFloat(price_max) ){
    	price_max_ok.push(price_min_ok[i])
    }
  	
  }
    
  
  for (i = 0;i < price_max_ok.length;i++){
    append = true
  	description = price_max_ok[i].body_html.split('<br><b>')
    if (checkbox_values.length == 0){
    	append = true
    }
    else{
      for (z = 0; z < checkbox_values.length; z++ ){
        if (description.includes(checkbox_values[z]) ){
        	append = true
        }
        else{
        	append = false
        }

      }
    }
      
      if ( append == true ){
      	final_list.push(price_max_ok[i])
      }
    }
    
    
  header_title = $('#header').text();
  header_val = $('#header').attr("value");
  
  final_list = filter(final_list,header_title)
  
  if (order == 1){
  
 	final_list = final_list.sort(function(obj1, obj2) {
	// Ascending: first age less than the previous
	return obj1.variants[0].price - obj2.variants[0].price;
	})
  }
  
  if (order == 0){
  
 	final_list = final_list.sort(function(obj1, obj2) {

	return obj2.variants[0].price - obj1.variants[0].price;
	})
  }
  

 
   nb_pages = Math.ceil(final_list.length / 10)
   
   if (page_n < 1){
   	page_n = 1
   }
   
  if (page_n > nb_pages){
  	page_n = nb_pages
  }
   
   $( ".pagination2" ).empty();
   
   $( ".pagination2" ).append( "<a onclick='previous_page(),reload()' >&laquo;</a>" );

  if (nb_pages <= 30) {
  for (i=0;i < nb_pages;i++){
    z = i +1
    if ( z == parseInt(page_n)){
    	var a_style='text-decoration: underline;'
    }
    else{
   	 var a_style='text-decoration: none;'
    }
  	$( ".pagination2" ).append( "<a class='page-number' style='"+ a_style +"' id="+z.toString()+" onclick='change_page(this.id)'>"+z.toString() +"</a>" );
  }
  	$( ".pagination2" ).append( "<a  class='page-number' onclick='next_page(),reload()' >&raquo;</a>" );
  }
  
  else {
    if (page_n > 11){
    	 	$( ".pagination2" ).append( "<a class='page-number' style='"+ a_style +"' id='1' onclick='change_page(this.id)'>1</a>" );
     		 $( ".pagination2" ).append( "<a class='page-number'  >...</a>" );		
  
    }
    page_n = parseInt(page_n)
    list_pages = []
    for (i = 0; i <= 10;i++){
      list_pages.unshift(page_n - i)
      list_pages.push(page_n + i+1)
    }
    console.log(list_pages)
  list_pages = list_pages.filter(function(x){ return x > 0 });
    list_pages = list_pages.filter(function(x){ return x <= nb_pages });

  
  for (i=0;i < list_pages.length;i++){
    z = list_pages[i]
    if ( page_n == z){
    	var a_style='text-decoration: underline;'
    }
    else{
   	 var a_style='text-decoration: none;'
    }
  	$( ".pagination2" ).append( "<a class='page-number' style='"+ a_style +"' id="+z.toString()+" onclick='change_page(this.id)'>"+z.toString() +"</a>" );
  }
    if (!list_pages.includes(nb_pages)){
    	$( ".pagination2" ).append( "<a class='page-number'  >...</a>" );
      $( ".pagination2" ).append( "<a class='page-number' style='"+ a_style +"' id="+nb_pages.toString()+" onclick='change_page(this.id)'>"+nb_pages.toString() +"</a>" );
    }
    
  	$( ".pagination2" ).append( "<a  class='page-number' onclick='next_page(),reload()' >&raquo;</a>" );
  }
    

  
	list_display = []
    
    end = parseInt(page_n)*10
    start = end - 10
    if (end > final_list.length ) {
    	end = final_list.length
    }

  for (i = start; i < end; i++){
  	list_display.push(final_list[i])
  }
  

  $( "#prod_div" ).empty();
  for (i = 0;i < list_display.length; i++){
    try {
        image = list_display[i].images[0].src
      }
    catch(err) {
        image = 'https://cdn.shopify.com/s/files/1/0006/3029/2540/files/coming-soon-image.png?16982896618171952396'
      }
     try {
        titl = list_display[i].title
      }
    catch(err) {
      if (final_list.length > 0) {

         location.reload();
          reloaded = true
        
        
      }
      else {
      	 $( "#prod_div" ).append("")
      }
      }
     
    
    if(header_title.includes("Configure") == true){
        $( "#prod_div" ).append( "<div id='product'>\
							<a href='/products/"+list_display[i].handle+"'><div style='cursor: pointer;' id='" +list_display[i].handle+ "' class='image'><img alt='Product Image' src='" +image+"'></div></a>\
							<div id='description'>\
							<a href='/products/"+list_display[i].handle+"'><p style='cursor: pointer;' id='" +list_display[i].handle+ "' class='title'>"+list_display[i].title+"</p></a>\
							<p id='specification'>"+list_display[i].body_html+"</p>\
							<div id='prod_lower'>\
<div id='price'><span style='font-size:17px;color:grey'>Starting at: </span><span style='font-weight:bold'>$"+list_display[i].variants[0].price+"</span></div>\
<div id='btn'><a target='view' id='" +list_display[i].handle+ "' href='"+ header_val +"/products/"+list_display[i].handle+"' class='configure_to_order_btn btn' >Configure Now</a></div>\
                            </div>\
                            </div>\
                            </div>" );
    
    }
    else{
    $( "#prod_div" ).append( "<div id='product'>\
							<a href='/products/"+list_display[i].handle+"'><div style='cursor: pointer;' id='" +list_display[i].handle+ "' class='image'><img alt='Product Image' src='" +image+"'></div></a>\
							<div id='description'>\
							<a href='/products/"+list_display[i].handle+"'><p style='cursor: pointer;' id='" +list_display[i].handle+ "' class='title'>"+list_display[i].title+"</p></a>\
							<p id='specification'>"+list_display[i].body_html+"</p>\
							<div id='prod_lower'>\
<div id='price'><span style='font-weight:bold'>$"+list_display[i].variants[0].price+"</span></div>\
<div id='btn'><a target='view' id='" +list_display[i].handle+ "' href='"+ header_val +"/products/"+list_display[i].handle+"' class='configure_to_order_btn btn' >View Product</a></div>\
<div id='btn'><a target='add' id='" +list_display[i].variants[0].id+ "' onclick='add_to_cart(this.id)' class='configure_to_order_btn btn' >Add To Cart</a></div>\
                            </div>\
                            </div>\
                            </div>" );
    }
  }
  
  collection_title = $( "#header" ).text()
  collection_name = collection_title.split("(")[0]
  collection_new = collection_name +" (" + String(final_list.length) +")"
  $( "#header" ).empty();
  $( "#header" ).append(collection_new);
  

  
    };


